import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'vfs-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SlideToggleComponent)
    }
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class SlideToggleComponent implements OnInit {
  @Input() formControlName: string;
  @Input() formControl: FormControl;
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Input() id: string;
  @Input() labelPosition: 'before' | 'after';
  @Input() name: string | null;
  @Input() required: boolean;
  @Output() changeEvt = new EventEmitter<MatSlideToggleChange>();
  @Output() dragChangeEvt = new EventEmitter<void>();
  @Output() toggleChangeEvt = new EventEmitter<void>();
  @Input() labelActive: string | null;
  @Input() labelNotActive: string | null;

  value: any;

  onChange = (rating: number) => {};
  onTouched = () => {};

  ngOnInit() {
    if (this.formControl && this.formControlName) {
      console.warn('Use formControl or formControlName, but not both');
    }
    this.showStatus(this.checked);
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.showStatus(this.value === true);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  change(evt: MatSlideToggleChange) {
    this.showStatus(evt.checked);
    this.changeEvt.emit(evt);
  }

  dragChange(evt: void) {
    this.dragChangeEvt.emit(evt);
  }

  toggleChange(evt: void) {
    this.toggleChangeEvt.emit(evt);
  }

  showStatus(isChecked: boolean) {
    if (this.labelActive && isChecked) {
      this.name = this.labelActive;
    }

    if (this.labelNotActive && !isChecked) {
      this.name = this.labelNotActive;
    }
  }
}
